
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organizations",
      function () {
        return require("private-next-pages/organizations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organizations"])
      });
    }
  